import { useTranslation } from "react-i18next";
import * as yup from "yup";

// bulk distributes every video of every selected release, so it has no videos field to validate
const useReleaseVideoDistributionSchema = (hasBulkDistributions) => {
    const { t } = useTranslation();

    const required = t("messages.inputMsgs.required");

    const invalidDate = t("messages.inputMsgs.invalidDate");

    return yup.object({
        client: yup.string().required(required),
        distributionType: yup.string(),
        releaseDate: yup
            .date()
            .transform((oldValue, newValue) => (newValue === "" ? null : oldValue))
            .typeError(invalidDate)
            .nullable()
            .required(required),
        territory: yup.string().required(required),
        videos: hasBulkDistributions ? yup.array().notRequired() : yup.array().min(1, required).required(required),
    });
};

export default useReleaseVideoDistributionSchema;
